import { BaseOption } from 'shared/types/types'

export type DialogBranchBaseOption = BaseOption<DialogBranches> & { icon: string }

export enum DialogBranches {
  regularChat = 'regularChat',
}

export interface IChatMessageDTO {
  answer: string
  answerTime: string
  needScore: boolean
}

export type MessagesType = {
  text: string
  me: boolean
  answerTime: string
}
